import React, { useEffect } from "react";

//libraries
import {
  Form,
  Input,
  Radio,
  Select,
  Button,
  Upload,
  Switch,
  Tooltip,
  Alert,
  Avatar,
  message,
  Tabs,
  Typography,
  Spin,
  Modal
} from "antd";


import { PaperClipOutlined } from "@ant-design/icons";
import KnowledgeBase from "../../../Pages/KnowledgeBase";
// Custom ConversationStater component
import ConversationStater from "./ConversationStater";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { TreeSelect } from 'antd';

//Constants
import { assistantGptModels, modelDescriptions, modelNameMapping } from "../../../constants/AssistanceModelConst";
import { ASSISTANT_CODE_INTERPRETER_NOTE, ASSISTANT_FILE_CREATION_NOTE, ASSISTANT_RETRIEVAL_NOTE } from "../../../constants/FileLIstConstants";
import { useState } from "react";
import { getAllFunctionDefinitions } from "../../../Pages/SuperAdmin/api/functionDefinition";
import { getAllAssistantType } from "../../../api/assistantTypeApi";
import { getAllIndustryType } from "../../../api/industryType";
import { RAGTree } from "../../KnowledgeBase/RAGTree";
import { FileContext } from "../../../contexts/FileContext";
import { useContext } from "react";
import { Layout } from 'antd';
import './RAGFileList.css';
import workBoardIcon from '../../../assests/images/workboard.png';
import googleDriveIcon from '../../../assests/images/google-drive-icon.png';
import webPageIcon from '../../../assests/images/webpageicon.png';
import hubspotIcon from '../../../assests/images/hubspot.jpg';
import activeCollabIcon from '../../../assests/images/activeCollab.png';
import axios from "axios"
import slackIcon from "../../../assests/images/slacklogo.png"
import { SLACK_CHANNELS_URL } from "../../../constants/Api_constants";
import {
  getAllApis,
} from "../../../Pages/SuperAdmin/api/functionDefinition";
import { getAllServices } from "../../../api/api_endpoints";
import { getCompId, getUserRole } from "../../../Utility/service";
import { Option } from "antd/es/mentions";

const { Sider, Content } = Layout;
const { TabPane } = Tabs;
const { Title, Text } = Typography;

// local component
const AssistantFileUploadMessage = () => {
  return <>
    <p>
      {ASSISTANT_FILE_CREATION_NOTE}
    </p>
    <ul>
      <li>
        {ASSISTANT_RETRIEVAL_NOTE}
      </li>
      <li>
        {ASSISTANT_CODE_INTERPRETER_NOTE}
      </li>
    </ul>
  </>
}

const AssistantForm = ({ data }) => {
  const {
    form,
    handleFormChange,
    handleSwitchChange,
    isAdmin,
    handleUploadFileAndCreateAssistant,
    fileList,
    setFileList,
    setCountTotalFile,
    countTotalFile,
    isUploading,
    handleRemoveFile,
    handleAddFile,
    assistantData,
    setAssistantData,
    editMode,
    image,
    setImage,
    setDeleteFileIds,
    formattedRAGdData,
    formattedPublicFilesData,
    knowledgeSource,
    setKnowledgeSource,
    activeKeyOfKnowledgeBase,
    setActiveKeyOfKnowledgeBase,
    setTotalFileList,
    connectApps, setConnectApps,
    isWorkBoardConnected, setIsWorkBoardConnected,
    isGoogleDriveConnected, setIsGoogleDriveConnected,
    isImportWebPagesConnected, setIsImportWebPagesConnected,
    isActiveCollabConnected, setIsActiveCollabConnected,
    enableSync,
    setEnableSync,
    handleSwitchChangeOfPlugin,
    selectedPlugins,
    setSelectedPlugins,
    isHubspotConnected, setIsHubspotConnected,
    fetchPipelines,
    handleToggleHubspotIntegration,
    handleHubspotChange,
    handleToggleSlackIntegration,
    handleSelectChannel,
    setSelectedChannelId,
    selectedChannelId,
    isModalOpen,
    setIsModalOpen,
    selectedChannelName,
    setSelectedChannelName,
    hubspotPipelines,
    imageType,
    setImageType,
    dalleImageDescription,
    setDalleImageDescription,
    functionCount,
    setFunctionCount,
    deletedFileList,
    setDeletedFileList,
    accept,
    isUploadAllowed,
    allowedFileTypes,
    setIsBrandVoiceEnabled,
    isBrandVoiceEnabled,
  } = data;

  useEffect(() => {
    if (editMode && assistantData) {
      setImageType(assistantData.imageType || "DEFAULT");
      form.setFieldsValue({ photoOption: assistantData.photoOption });
    }
  }, [editMode, assistantData, form]);

  if (hubspotPipelines && hubspotPipelines?.length > 0) {
    setIsHubspotConnected(assistantData?.hubspotPipelines);
  }

  const userRole = getUserRole()
  const currentOrgId = getCompId()


  const knowledgeBaseSourceInitialValue = editMode ? form.getFieldValue('knowledgeSource') : false;
  const isSync = !editMode ? setEnableSync(false) : null;


  const { TextArea } = Input;
  const photoOption = form.getFieldValue('photoOption');
  const [assistantTypes, setAssistantTypes] = useState([]);
  const [industryTypes, setIndustryTypes] = useState([]);
  const [functionDefinitions, setFunctionDefinitions] = useState([]);
  const [folderStructure, setFolderStructure] = useState([]);
  const [files, setFiles] = useState([]);
  const [allUsersFileTreeStructure, setAllUsersFileTreeStructure] = useState([]);
  const [previousSelectedKB, setPreviousSelectedKB] = useState([]);
  const [previousUploadedFiles, setPreviousUploadedFiles] = useState([]);

  const { selectedFile, setSelectedFile, setSelectedFolders } =
    useContext(FileContext);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [serviceApis, setServiceApis] = useState([]);
  const [serviceIcons, setServiceIcons] = useState([]);
  const [channels, setChannels] = useState([]);
  const filteredChannels = channels.filter((channel) =>
    channel.name.toLowerCase().includes(search.toLowerCase())
  );
  const [isSlackConnected, setIsSlackConnected] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filesManuallyCleared, setFilesManuallyCleared] = useState(false);
  const [isSelectedFilesSeted, setIsSelectedFilesSeted] = useState(false);
  useEffect(() => {
    if (knowledgeSource) {
      setActiveKeyOfKnowledgeBase('2');
    } else {
      setActiveKeyOfKnowledgeBase('1');
    }
  }, [knowledgeSource]);

  const handleSwitchChangeOfSource = (checked) => {
    setKnowledgeSource(checked);
    form.setFieldsValue({ knowledgeSource: checked });

  };

  const handleSwitchChangeOfEnableSync = (checked) => {
    setEnableSync(checked);
    form.setFieldsValue({ enableSync: checked });
  };

  const handleSwitchChangeOfSlack = async (checked) => {
    setIsSlackConnected(checked);
    form.setFieldsValue({ slack: checked });
    if (checked) {
      await fetchChannels();
      setIsModalOpen(true)
    }
  };

  const fetchChannels = async () => {
    setLoading(true);
    try {
      const oauthToken = localStorage.getItem("oauthToken");
      const response = await axios.get(
        `${SLACK_CHANNELS_URL}?oauthToken=${oauthToken}`
      );
      if (response.data.success) {
        setChannels(response.data.data);
      } else {
        console.error("Error fetching channels:", response.data.error);
      }
    } catch (error) {
      console.error("Error fetching Slack channels:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const [isHubspotEnabled, setHubspotEnabled] = useState(false);
  const HubspotIntegration = (checked) => {
    setHubspotEnabled(true);

    // Handle toggle state change
    if (!checked) {
      setHubspotEnabled(false);
    }
  };

  const handleSwitchChangeOfActiveCollab = (checked) => {
    setIsActiveCollabConnected(checked);
    form.setFieldsValue({ activeCollab: checked });
  };

  const handleSwitchChangeOfConnectApps = (appWithState) => {
    const key = Object.keys(appWithState)[0];
    const value = Object.values(appWithState)[0];

    const updatedAppsWithState = connectApps.map((app) => {
      const appKey = Object.keys(app)[0];
      if (appKey === key) {
        return appWithState;
      }
      return app;
    });

    const isAppPresent = connectApps.some((app) => Object.keys(app)[0] === key);
    const finalAppsWithState = isAppPresent
      ? updatedAppsWithState
      : [...updatedAppsWithState, appWithState];
    setConnectApps(finalAppsWithState);
    form.setFieldsValue({ connectApps: finalAppsWithState });
    form.setFieldsValue(appWithState);

    if (key === "workBoard") {
      setIsWorkBoardConnected(value);
    }
    if (key === "googleDrive") {
      setIsGoogleDriveConnected(value);
    }
    if (key === "importWebPages") {
      setIsImportWebPagesConnected(value);
    }
    if (key === "hubspot") {
      setIsHubspotConnected(value);
    }
    if (key === "activeCollab") {
      setIsActiveCollabConnected(value);
    }
    if (key === "slack") {
      setIsSlackConnected(value);
    }

  };

  const handleFileSelect = (file) => {
    setSelectedFile(file);
  };

  const formData = new FormData();
  const handleDelete = (key) => {
    if (editMode) {
      const fileIds = assistantData?.fileIdsWithKeysOfKnowledgeBase?.filter((file) => file.key === key);
      if (fileIds?.[0]?.file_id) {
        setDeleteFileIds((prev) => prev.length ? [...prev, fileIds[0].file_id] : [fileIds[0].file_id]);
      }
      // Add to deletedFileList for tracking deleted files in edit mode
      setDeletedFileList(prev => [...prev, key]);
    }

    // Update selectedFile state using functional update to ensure we're working with latest state
    setSelectedFile(prevFiles => {
      const updatedFiles = prevFiles.filter(file => file.key !== key);
      // If this was the last file, also clear selectedFolders
      if (updatedFiles?.length === 0) {
        setSelectedFolders([]);
        form.setFieldsValue({ fileNameList: [] });
        setFilesManuallyCleared(true);
      }

      return updatedFiles;
    });

    setSelectedFolders(prev => prev.filter(folderKey => folderKey !== key));
  };

  const getAllfunctions = async () => {
    const functions = await getAllFunctionDefinitions();
    setFunctionDefinitions(functions);
  }

  const getAllServiceApi = () => {
    getAllApis((serviceApis) => {
      setServiceApis(serviceApis);
    });
  };

  useEffect(() => {
    const fetchServices = async () => {
      setLoading(true);
      try {
        const response = await getAllServices();

        if (response?.data?.data && Array.isArray(response.data.data)) {
          const serviceDetails = response.data.data.map((service) => ({
            service_id: service._id,
            service_icon: service.service_icon || "",
          }));
          setServiceIcons(serviceDetails);
        } else {
          console.warn(
            "Expected an array inside response.data.data, but received:",
            response,
          );
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);

  const handleChange = (newFileList) => {
    if (fileList.length > 0) {
      setCountTotalFile(newFileList.fileList.length);

    }

  };

  const uploadProps = {
    onRemove: handleRemoveFile,
    onChange: handleChange,
    beforeUpload: handleAddFile,
    fileList,
    multiple: true,

  };
  //------Side effects---------//


  useEffect(() => {
    if (assistantData) {
      form.setFieldsValue({
        ...form.getFieldsValue(), // Spread current form values to avoid resetting
        ...assistantData, // Update with any new data
        upload: fileList, // Preserve the fileList by explicitly setting it
      });

      setPreviousSelectedKB(assistantData?.knowledgeBaseInfo);
      setPreviousUploadedFiles(assistantData?.fileNames);
      getAllAssistantType(setAssistantTypes);
      getAllIndustryType(setIndustryTypes);
      getAllfunctions();
      getAllServiceApi();
      if (!isSelectedFilesSeted) {
        setSelectedFile(assistantData?.knowledgeBaseInfo || []);
        setIsSelectedFilesSeted(true);
      }

    }
  }, [assistantData, form, fileList, deletedFileList]);

  useEffect(() => {
    if (selectedFile.length === 0 && editMode) {
      // Ensure the form value is also cleared
      form.setFieldsValue({ fileNameList: JSON.stringify([]) });
    }
    if (!filesManuallyCleared) {
      const nonDeletedFiles = selectedFile?.filter(
        file => !deletedFileList.includes(file.key)
      );
      setSelectedFile(nonDeletedFiles || []);
    }
  }, [selectedFile, editMode, form, deletedFileList]);
  //-----Local functions-------//


  const typeArray = [];
  for (let type in assistantTypes) {
    typeArray.push(assistantTypes[type].name);

  }

  const industryTypeArray = [];
  for (let type in industryTypes) {
    industryTypeArray.push(industryTypes[type].name);

  }

  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      onFinish={handleUploadFileAndCreateAssistant}
      layout="vertical"
    >
      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: "This field is mandatory." }]}
      >
        <Input placeholder="Enter name" />
      </Form.Item>

      {assistantData?.image_url ? (
        <Avatar size="large" className="mb-2" src={assistantData?.image_url} />
      ) : null}

      <Form.Item
        label="Select/Generate Image"
        name="photoOption"
        rules={[
          {
            required: false,
            message: "Please Select the type of Agent photo",
          },
        ]}
      >
        <Radio.Group
          defaultValue={assistantData.imageType}
          value={assistantData?.imageType}
          onChange={(e) => {
            const selectedValue = e.target.value;
            setImageType(selectedValue); // Set image type
            form.setFieldsValue({ photoOption: selectedValue });
            if (selectedValue !== "DALLE") {
              setDalleImageDescription("");
            }
            setAssistantData((prevData) => {
              return {
                ...prevData,
                imageType: selectedValue,
              };
            });
          }}
        >
          <Radio value="DEFAULT">Default Avatar</Radio>
          <Radio value="UPLOAD">Upload</Radio>
          <Radio value="DALLE">Dall-E</Radio>
        </Radio.Group>
      </Form.Item>

      {imageType === "DALLE" && (
        <Form.Item
          label="DALL-E Image Description"
          name="dalleImageDescription"
          initialValue={editMode ? dalleImageDescription : ""}
          rules={[
            {
              required: false,
              message: "Please enter a description for the DALL-E image.",
            },
          ]}
        >
          <Input.TextArea
            rows={3}
            placeholder="Enter description for DALL-E image"
            value={dalleImageDescription}
            onChange={(e) => {
              setDalleImageDescription(e.target.value);
              // form.setFieldsValue({ dalleImageDescription: e.target.value });
            }}
          />
        </Form.Item>
      )}

      {photoOption === "UPLOAD" && (
        <Form.Item
          label="Upload Photo"
          name="avatar"
          rules={[
            {
              required: true,
              message: "Please upload a photo",
            },
          ]}
        >
          {assistantData.imageType === "UPLOAD" && assistantData.image_url && (
            <img
              style={{
                height: "32px",
                width: "32px",
                marginBottom: "5px",
                borderRadius: "7px",
                border: "1px solid black",
              }}
              src={assistantData.image_url}
              alt="Uploaded"
            />
          )}
          <Upload
            maxCount={1}
            accept="image/*"
            beforeUpload={(file) => {
              const isImage = file.type.startsWith("image/");
              if (!isImage) {
                console.log("You can only upload image files!");
              } else {
                setImage(file);
                form.setFieldsValue({ avatar: file });
              }
              return false;
            }}
          >
            <Button>Upload</Button>
          </Upload>
        </Form.Item>
      )}

      <Form.Item
        label="Instructions"
        name="instructions"
        rules={[
          {
            required: true,
            message: "Please enter the instructions",
          },
        ]}
      >
        <TextArea
          style={{
            resize: "vertical",
            scrollbarWidth: "thin",
            scrollbarColor: "#888 #41414e",
          }}
          rows={3}
          placeholder="You are a helpful Agent."
        />
      </Form.Item>
      <Form.Item
        label="Description"
        name="description"
        rules={[
          {
            required: true,
            message: "Please enter the description",
          },
        ]}
      >
        <TextArea
          style={{
            resize: "vertical",
            scrollbarWidth: "thin",
            scrollbarColor: "#888 #41414e",
          }}
          rows={2}
          placeholder="Enter Description"
        />
      </Form.Item>
      <Form.Item
        label="Select Category"
        name="assistantTypes"
        rules={[
          {
            required: true,
            message: "Please Select Agent Category",
          },
        ]}
      >
        <Select placeholder="Choose">
          {typeArray.map((types) => (
            <Select.Option key={types} value={types}>
              {types}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      {userRole === "superadmin" && (
        <Form.Item
          label="Select Industry type"
          name="industryTypes"
        >
          <Select
            mode="multiple"
            placeholder="Choose"
            allowClear
          >
            {industryTypeArray.map((types) => (
              <Select.Option key={types} value={types}>
                {types}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      )}

      {isAdmin && (
        <Form.Item
          label="Select type"
          name="category"
          rules={[
            {
              required: true,
              message: "Please Select the type of Agent",
            },
          ]}
        >
          <Radio.Group>
            <Radio value="ORGANIZATIONAL">Organizational</Radio>
            <Radio value="PERSONAL">Personal</Radio>
          </Radio.Group>
        </Form.Item>
      )}

      <Form.Item label="Conversation Starters" name="static_questions">
        <ConversationStater
          staticQuestions={assistantData?.static_questions}
          onAddQuestion={(question) =>
            setAssistantData((prevData) => ({
              ...prevData,
              static_questions: [
                ...(prevData.static_questions || []),
                question,
              ],
            }))
          }
          setAssistantData={setAssistantData}
        />
      </Form.Item>
      {/* <Form.Item
        label="Model"
        name="model"
        rules={[
          {
            required: true,
            message: "Please Select GPT Model",
          },
        ]}
      >
        <Select showSearch optionFilterProp="label">
          {assistantGptModels.map((model) => (
            <Select.Option
              key={model.value}
              value={model.value}
              label={model.label}
            >
              <strong>{model.value}</strong> –{" "}
              <span style={{ color: "#888" }}>{model.label.split("–")[1]}</span>
            </Select.Option>
          ))}
        </Select>
      </Form.Item> */}

<Form.Item
        label="Model"
        name="model"
        rules={[
          {
            required: true,
            message: "Please Select GPT Model",
          },
        ]}
      >
        <Select optionLabelProp="label" placeholder="Select a GPT Model">
          {assistantGptModels.map((model) => (
            <Option
              key={model}
              value={model}
              label={modelNameMapping[model] || model}
            >
              <div>
                <strong>{modelNameMapping[model] || model}</strong>
                <br />
                <small style={{ color: "#888" }}>
                  {modelDescriptions[model]}
                </small>
              </div>
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label={<span style={{ fontWeight: "bold" }}>Plugins</span>}
        name="plugins"
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "0px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <span>File Sync</span>
          <Tooltip title="By enabling this feature,you can sync your google drive files and WorkBoard files from agent chat page.">
            <Switch
              checked={form.getFieldValue("plugins")?.includes("enableSync")}
              onChange={(checked) =>
                handleSwitchChangeOfPlugin("enableSync", checked)
              }
            />
          </Tooltip>
        </div>

        {/* <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <span>Mermaid</span>
          <Tooltip title="By enabling this feature you can generate graph during chat with agent">
            <Switch
              checked={form.getFieldValue("plugins")?.includes("mermaid")}
              onChange={(checked) => handleSwitchChangeOfPlugin("mermaid", checked)}
            />
          </Tooltip>
        </div> */}

        {/* <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Function Calling</span>
          <Tooltip title="It enables the Agent to call the custom functions">
            <Switch
              checked={form.getFieldValue("tools")?.includes("function")}
              onChange={(checked) => (
                handleSwitchChange("function", checked),
                formData.append('functionCalling', checked))
              }
            />
          </Tooltip>
        </div> */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <span style={{minWidth:"120px"}}>Brand Voice</span>
          <Tooltip title="By enabling this feature you can use brand icons in chat responses">
            <Switch
              checked={form.getFieldValue("plugins")?.includes("brand_icon")}
              onChange={(checked) =>{
                handleSwitchChangeOfPlugin("brand_icon", checked);
                setIsBrandVoiceEnabled(checked);
                if(checked){
                  handleSwitchChange("file_search", checked)
                }
              }}
            />
          </Tooltip>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <span>Flux</span>
          <Tooltip title="By enabling this feature you can generate image during chat with agent">
            <Switch
              checked={form.getFieldValue("plugins")?.includes("flux")}
              onChange={(checked) =>
                handleSwitchChangeOfPlugin("flux", checked)
              }
            />
          </Tooltip>
        </div>
      </Form.Item>

      <hr />
      {!knowledgeSource && (
        <Form.Item
          label={<span style={{ fontWeight: "bold" }}>Tools</span>}
          name="tools"
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "0px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <span>Code interpreter</span>
            <Tooltip title="Code Interpreter enables the Agent to write and run code. This tool can process files with diverse data and formatting, and generate files such as graphs.">
              <Switch
                checked={form
                  .getFieldValue("tools")
                  ?.includes("code_interpreter")}
                onChange={(checked) =>
                  handleSwitchChange("code_interpreter", checked)
                }
              />
            </Tooltip>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <span>File search</span>
            <Tooltip title="File search enables the Agent with knowledge from files that you or your users upload. Once a file is uploaded, the Agent automatically decides when to retrieve content based on user requests.">
              <Switch
                checked={form.getFieldValue("tools")?.includes("file_search")}
                onChange={(checked) =>
                  handleSwitchChange("file_search", checked)
                }
              />
            </Tooltip>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>Function Calling</span>
            <Tooltip title="It enables the Agent to call the custom functions">
              <Switch
                checked={form.getFieldValue("tools")?.includes("function")}
                onChange={(checked) => (
                  handleSwitchChange("function", checked, functionCount),
                  formData.append("functionCalling", checked)
                )}
              />
            </Tooltip>
          </div>
        </Form.Item>
      )}

      <>
        {form.getFieldValue("tools")?.includes("function") && (
          <Form.Item
            label="Function List"
            name="functions"
            rules={[
              {
                required: form.getFieldValue("tools")?.includes("function"),
                message:
                  "Please select at least one function or disable function calling tool",
              },
            ]}
          >
            <Select
              mode="multiple"
              placeholder="Select functions"
              onChange={(selectedFunctions) => {
                setFunctionCount(selectedFunctions.length);
              }}
            >
              {functionDefinitions
                ?.filter((func) => !func.service_id) // Exclude functions with service_id
                .map((func) => (
                  <Select.Option key={func._id} value={JSON.stringify(func)}>
                    {func.title}
                  </Select.Option>
                ))}
              {/* Render options from serviceApis */}
              {serviceApis?.flatMap((service) => {
                return service.apis.map((api) => {
                  const serviceId =
                    api.service_id && api.service_id.$oid
                      ? api.service_id.$oid
                      : api.service_id || null;
                  const matchedService = serviceIcons.find(
                    (s) => s.service_id === serviceId
                  );
                  return (
                    <Select.Option
                      key={api._id?.$oid || api._id}
                      value={JSON.stringify(api)}
                    >
                      {matchedService && matchedService.service_icon ? (
                        <img
                          src={`${process.env.REACT_APP_BASE_URL}${matchedService?.service_icon}`}
                          alt="Service Icon"
                          style={{ width: 20, height: 20, marginRight: 8 }}
                        />
                      ) : (
                        <span></span>
                      )}
                      {api.api_name}
                    </Select.Option>
                  );
                });
              })}
            </Select>
          </Form.Item>
        )}
      </>
      <hr />

      <Tabs
        activeKey={activeKeyOfKnowledgeBase}
        onChange={setActiveKeyOfKnowledgeBase}
        defaultActiveKey="1"
      >
        <TabPane
          tab="Add"
          key="1"
          disabled={knowledgeSource}
          className={knowledgeSource ? "blurred-tab" : ""}
        >
          <Form.Item
            label="FILES"
            name="upload"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
          >
            <Alert
              className="mb-2"
              message={<AssistantFileUploadMessage />}
              type="info"
              showIcon
            />
            <Tooltip title="By uploading files, you enable the Agent to use the content from these files for file_search and code interpreter.">
              <Upload {...uploadProps} fileList={fileList} accept={accept}>
                <Button
                  icon={<PaperClipOutlined />}
                  disabled={countTotalFile >= 20 || !isUploadAllowed}
                >
                  {" "}
                  Add
                </Button>
              </Upload>
              {isUploadAllowed ? (
                <p>Allowed file types: {allowedFileTypes.join(", ")}</p>
              ) : (
                <p>Please select tools to enable file uploads.</p>
              )}
              {countTotalFile ? (
                <p>
                  <b>Files Selected : {countTotalFile}</b>
                </p>
              ) : (
                ""
              )}
            </Tooltip>
          </Form.Item>
        </TabPane>

        <TabPane
          tab="Upload From Knowledge Base"
          key="2"
          // disabled={!knowledgeSource}
          className={!knowledgeSource ? "blurred-tab" : ""}
        >
          <div>
            <p>Knowledge Base</p>
            <RAGTree
              formattedRAGdData={formattedRAGdData}
              // formattedPublicFilesData={formattedPublicFilesData?.filter(file => file.orgId === currentOrgId)}
              formattedPublicFilesData={formattedPublicFilesData}
              selectedTools={form.getFieldValue("tools")}
              knowledgeSource={knowledgeSource}
              selectedFile={selectedFile}
              setSelectedFile={setSelectedFile}
            />
            <Alert
              className="mb-2"
              message={<AssistantFileUploadMessage />}
              type="info"
              showIcon
            />
            {selectedFile?.length > 0 && (
              <ul className="file-list">
                {form.getFieldValue("tools")?.length > 0 &&
                  form
                    .getFieldValue("tools")
                    .some((tool) =>
                      ["code_interpreter", "file_search", "function"].includes(
                        tool
                      )
                    ) ? (
                  <>
                    <h3>Selected Files</h3>
                    <ul>
                      {selectedFile?.map((file) => (
                        <li key={file?.key} className="file-list-item">
                          {file?.title}
                          <span className="delete-button">
                            <Button
                              onClick={() => handleDelete(file?.key)}
                              icon={<AiOutlineDelete />}
                            />
                          </span>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  (() => {
                    if (selectedFile?.length > 0) {
                      message.error(
                        `Unsupported file type: ${selectedFile[0].title}. Please select files that are supported for your enabled tools.`
                      );
                    }
                    setSelectedFile([]);
                    setSelectedFolders([]);
                    return null;
                  })()
                )}
                <Form.Item
                  name="fileNameList"
                  hidden
                  initialValue={JSON.stringify(selectedFile)}
                >
                  <input type="hidden" />
                </Form.Item>
              </ul>
            )}
          </div>
        </TabPane>
      </Tabs>

      <Form.Item>
        &nbsp;&nbsp;&nbsp;
        {isUploading() && knowledgeSource ? (
          <Alert
            className="mb-2"
            message={
              "It takes some time for files to get indexed. Please wait until we create an RAG Agent for you."
            }
            type="info"
            showIcon
          />
        ) : (
          ""
        )}
        &nbsp;&nbsp;&nbsp;
        <Button
          style={{ display: "block", marginLeft: "auto" }}
          type="primary"
          htmlType="submit"
          // onClick={handleUploadFileAndCreateAssistant}
          loading={isUploading()}
          disabled={countTotalFile >= 21 || selectedFile?.length >= 21}
        >
          {isUploading()
            ? "Loading..."
            : editMode
              ? "Update Agent"
              : "Create Agent"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AssistantForm;
